import { render, staticRenderFns } from "./addMerchant.vue?vue&type=template&id=141c6b3e&scoped=true"
import script from "./addMerchant.vue?vue&type=script&lang=ts"
export * from "./addMerchant.vue?vue&type=script&lang=ts"
import style0 from "./addMerchant.vue?vue&type=style&index=0&id=141c6b3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141c6b3e",
  null
  
)

export default component.exports